/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_No_Folder_SelectedInputs */

const en_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No folder selected`)
};

const fr_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun dossier sélectionné`)
};

const de_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Ordner ausgewählt`)
};

const it_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna cartella selezionata`)
};

const ru_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Папка не выбрана`)
};

const es_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay ninguna carpeta seleccionada`)
};

const zh_cn2_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择文件夹`)
};

const ja_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダが選択されていません`)
};

const hi_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई फ़ोल्डर चयनित नहीं है`)
};

const pt_pt2_audio_description_export_no_folder_selected = /** @type {(inputs: Audio_Description_Export_No_Folder_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma pasta selecionada`)
};

/**
* | output |
* | --- |
* | "No folder selected" |
*
* @param {Audio_Description_Export_No_Folder_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_no_folder_selected = /** @type {((inputs?: Audio_Description_Export_No_Folder_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_No_Folder_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_no_folder_selected(inputs)
	if (locale === "de") return de_audio_description_export_no_folder_selected(inputs)
	if (locale === "it") return it_audio_description_export_no_folder_selected(inputs)
	if (locale === "ru") return ru_audio_description_export_no_folder_selected(inputs)
	if (locale === "es") return es_audio_description_export_no_folder_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_no_folder_selected(inputs)
	if (locale === "ja") return ja_audio_description_export_no_folder_selected(inputs)
	if (locale === "hi") return hi_audio_description_export_no_folder_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_no_folder_selected(inputs)
	return en_audio_description_export_no_folder_selected(inputs)
});